import * as client from "../ClientConsumer";
import { generatePath } from "react-router-dom";
import { RequestCriteriaType } from "@infrastructure/Services/PostService.types";
import { prepareSearchCriteriaWithoutCaching } from "@infrastructure/Services/ApiUtility";

const routes = {
    GET_VIDEOS_PREVIEWS: "/groups/:groupId/video-posts-preview",
};

export type VideosPreviewType = {
    commentCount: number;
    postId: number;
    reactionCount: number;
    thumbnailUrl: string;
};

export function getVideosPreview(
    id: string,
    sortCriteria?: RequestCriteriaType,
): Promise<VideosPreviewType[]> {
    return client
        .getData(
            generatePath(routes.GET_VIDEOS_PREVIEWS, {
                groupId: id,
            }) + prepareSearchCriteriaWithoutCaching(sortCriteria),
        )
        .then((res) => res.data.previews);
}
